import constants from "../constants/contentFile.json";

const validateRegesterdMobileNumber = (regMobileNumber) => {
  const mobileNumber = /^[0-9]{10}$/;
  return mobileNumber.test(regMobileNumber);
};
export { validateRegesterdMobileNumber };

const validateOtp = (enteredOtp) => {
  const re = /^[0-9]{6}$/;
  return re.test(enteredOtp);
};
export { validateOtp };

// validate Token
export const getValidateToken = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");
  return token;
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const validateUserCredentials = (userId, password) => {
  const errorMsgs = constants.errorMessages;
  if (!userId && !password) {
    return errorMsgs.userIdandPasswordRequired;
  } else if (!userId) {
    return errorMsgs.userIdRequired;
  } else if (!password) {
    return errorMsgs.passwordRequired;
  } else {
    return true;
  }
};
export { validateUserCredentials };

export const processStatus = (status) => {
  if (status === "Accept") {
    return "Accepted";
  } else if (status === "Reject") {
    return "Rejected";
  } else {
    return status;
  }
};

export const nonEmpty = (value) => {
  if (value.length < 1) {
    return false;
  } else {
    return true;
  }
};

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const toRadians = (degrees) => degrees * (Math.PI / 180);

  const R = 6371; // Radius of the Earth in kilometers
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c * 1000; // Convert to meters

  return distance; // Distance in meters
};
